<loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

<div class="cs-page-list-grid">
  <!-- Filters Panel -->
  @if (filterConfig() && showFilters()) {
    <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
  }

  <!-- Data Table Panel -->
  <p-panel [header]="'Provider_Returns' | translateWF: 'Provider Returns'">
    <ng-template pTemplate="icons">
      <p-button
        [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
        [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
        (click)="showFilters.set(!showFilters())"
        variant="outlined"
        size="small"
      />
    </ng-template>
    <p-card data-variant="compact">
      <p-table [value]="providerReturnList()" [sortOrder]="1" selectionMode="single" [customSort]="true" (sortFunction)="onTableSort($event)">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 80px">{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
            <th pSortableColumn="number">
              {{ 'PR_Number' | translateWF: 'PR Number' }}
              <p-sortIcon field="number"></p-sortIcon>
            </th>
            <th>{{ 'PR_Return_Date' | translateWF: 'Return Date' }}</th>
            <th>{{ 'Common_Status' | translateWF: 'Status' }}</th>
            <th>{{ 'Common_Location' | translateWF: 'Location' }}</th>
            <th>{{ 'PR_Goods_Receipt_Number' | translateWF: 'Goods Receipt Number' }}</th>
            <th>{{ 'PR_Return_Reason' | translateWF: 'Return Reason' }}</th>
            <th>{{ 'PR_Created_By' | translateWF: 'Created By' }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-pr>
          <tr class="cursor-pointer">
            <td>
              <p-button
                icon="pi pi-eye"
                [rounded]="true"
                [text]="true"
                severity="info"
                (click)="navigateToDetail(pr.initiator.reference)"
                pTooltip="{{ 'Common_View_Details' | translateWF: 'View / Process' }}"
                tooltipPosition="top"
              />
            </td>
            <td>{{ pr.number }}</td>
            <td>{{ pr.returnDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-6' }}</td>
            <td>
              <p-tag [value]="getStatusLabel(pr.status)" [severity]="getStatusSeverity(pr.status)" />
            </td>
            <td>{{ localHelperService.getLocalizedValue(pr.locationName) || pr.locationCode }}</td>
            <td>{{ pr.goodsReceiptNumber || '-' }}</td>
            <td>{{ pr.returnReason }}</td>
            <td>{{ pr.createdBy }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" class="text-center">
              {{ 'PR_No_Returns_Found' | translateWF: 'No provider returns found' }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-paginator
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        [first]="(currentPage - 1) * pageSize"
        (onPageChange)="onPageChange($event)"
        [rowsPerPageOptions]="[15, 25, 50, 100]"
        dropdownAppendTo="body"
        class="mt-4"
      ></p-paginator>
    </p-card>
  </p-panel>
</div>
